import { render, staticRenderFns } from "./MarketingIcon.vue?vue&type=template&id=28e618c9&"
import script from "./MarketingIcon.vue?vue&type=script&lang=ts&"
export * from "./MarketingIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports